import React from 'react'
import { Domain } from '../../../core'
import stylesModule from './style.module.css'

interface Props {
  listSelect: Array<Domain.Product.ListSelect>,
  handleChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
}
function SelectComponent (props: Props) {
  const { listSelect, handleChange } = props;
  
  return (
    <select onChange={e => handleChange(e)} className={stylesModule.select}> 
      {
        listSelect.length > 0 &&
        listSelect.map((item: Domain.Product.ListSelect, index: number) => (
          <option value={item.id} key={index}>{item.name}</option>
        ))
      }
    </select>
  )
}

export default SelectComponent;
